@use '../../sass/theme';

/**
 * Theme options
 * @prop --jds-theme-card-color-bg: Background of the card
 * @prop --jds-theme-card-color-bg-inverse: Background of the card bod when inversed (defaults to header)
 * @prop --jds-theme-card-header-color-bg: Background of the card header
 * @prop --jds-theme-card-color-border: Border color for the card
 * @prop --jds-theme-card-color-border-highlight: Border highlight color
 */

:host {
  display: block;

  .card {
    font-family: var(--jui-font-family), sans-serif;
    border-radius: var(--jui-border-radius);
    border: 1px solid var(--jui-card-color-border);
    background-color: var(--jui-card-color-bg);
    transform: scale3d(1, 1, 1) translateZ(0);
    transition: transform 0.15s ease-in, box-shadow 0.15s ease-in;
    transition-delay: 0.1s;
    font-size: inherit;


    &__header {
      & ::slotted([slot='header']) {
        box-sizing: border-box !important;
        border-top-left-radius: var(--jui-border-radius);
        border-top-right-radius: var(--jui-border-radius);
        border-bottom: 1px solid var(--jui-card-color-border);
        background-color: var(--jui-card-header-color-bg);
        padding: var(--jds-space) var(--jds-space-lg);
        color: var(--jui-card-header-color-text);
        font-weight: var(--jds-theme-fw-bold, 500);
        font-size: var(--jds-theme-fs-sm, 1rem);
      }
    }

    &__body {
      & :not([footer]):not([header])::slotted(*) {
        box-sizing: border-box !important;
        padding: var(--jds-space-inset-lg);
      }
    }

    &__footer {
      & ::slotted([slot='footer']) {
        box-sizing: border-box !important;
        padding: var(--jds-space) var(--jds-space-lg);
        border-bottom-left-radius: var(--jui-border-radius);
        border-bottom-right-radius: var(--jui-border-radius);
        border-top: 1px solid var(--jui-card-color-border);
        //font-size: var(--jds-theme-fs-sm, 1rem);
      }
    }

    & ::slotted([slot='image']) {
      border-radius: var(--jui-border-radius);
      display: block;
      max-width: 100%;
    }

    // modifiers
    &--has-header {
      & ::slotted([slot='image']) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    &--has-footer {
      & ::slotted([slot='image']) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    &--sm {


      & .card__header ::slotted([slot='header']),
      & .card__footer ::slotted([slot='footer']) {
        font-size: var(--jds-theme-fs-sm, .9em);
        padding: var(--jds-space-sm) var(--jds-space);
      }

      & .card__body {
        & :not([footer]):not([header])::slotted(*) {
          padding: var(--jds-space-inset);
        }
      }
    }

    &--lg {


      & .card__header ::slotted([slot='header']),
      & .card__footer ::slotted([slot='footer']) {
        font-size: var(--jds-theme-fs, 1rem);
        padding: var(--jds-space-lg) var(--jds-space-xl);
      }

      & .card__body {
        & :not([footer]):not([header])::slotted(*) {
          padding: var(--jds-space-inset-xl);
        }
      }
    }

    &--squared {
      border-radius: 0;
      & .card__header ::slotted([slot='header']),
      & .card__footer ::slotted([slot='footer']),
      & ::slotted([slot='image']) {
        border-radius: 0;
      }
    }

    &--highlight {
      border: 1px solid var(--jui-primary-color);
      outline: 1px solid var(--jui-primary-color);
    }

    &--elevated {
      box-shadow: var(--jui-shadow);
    }

    &--no-borders {
      border: none;
    }

    &--inverse {
      background-color: var(--jui-card-color-bg-inverse);
      & .card__header ::slotted([slot='header']) {
        background-color: var(--jui-card-color-bg);
      }
      & .card__footer ::slotted([slot='footer']) {
        background-color: var(--jui-card-color-bg-inverse);
      }
    }

    &--hug-content {
      .card__body {
        :not([footer]):not([header])::slotted(*) {
          padding: 0 !important;
        }
      }
    }

    &--zoom {
      &:hover {
        transform: scale3d(1.048, 1.048, 1.048) translateZ(0);
        transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;
      }
      &.card--elevated:hover {
        box-shadow: var(--jui-shadow-md);
      }
    }
  }
}
